<aside
  class="sidebar-container"
  [class.collapsed]="showCollapsedUi"
  (mouseleave)="onSidebarMouseLeave()"
>
  <div class="sidebar-top">
    <img
      *ngIf="!showCollapsedUi"
      src="/ewents-logo-navy.svg"
      alt="Ewents Logo"
      class="sidebar-logo"
    />
    <img
      *ngIf="showCollapsedUi"
      src="/ewents-w-mark.svg"
      alt="Ewents"
      class="sidebar-logo sidebar-logo--mark"
    />
  </div>

  <button
    type="button"
    class="collapse-toggle"
    [attr.aria-label]="showCollapsedUi ? 'Expand sidebar' : 'Collapse sidebar'"
    [attr.aria-expanded]="!showCollapsedUi"
    [ewentsTooltip]="showCollapsedUi ? 'Expand' : 'Collapse'"
    ewentsTooltipPosition="right"
    (click)="toggleCollapsed($event)"
  >
    <mat-icon>{{ showCollapsedUi ? 'chevron_right' : 'chevron_left' }}</mat-icon>
  </button>

  <nav class="sidebar-nav" (scroll)="onSidebarNavScroll()">
    <div
      class="section-item-wrapper"
      *ngFor="let section of visibleSections; trackBy: trackBySection"
      #sectionWrapper
      (mouseenter)="onSectionMouseEnter(section, sectionWrapper)"
    >
      <button
        type="button"
        class="section-item"
        [class.active]="isSectionActive(section)"
        [ewentsTooltip]="
          showCollapsedUi && getSubmenuItems(section).length === 0 ? section.label : ''
        "
        ewentsTooltipPosition="right"
        (click)="onSectionClick(section, sectionWrapper)"
      >
        <div class="section-item-main">
          @if (resolveSvgIconName(section); as svgName) {
            <mat-icon class="section-icon" [svgIcon]="svgName"></mat-icon>
          } @else {
            <mat-icon class="section-icon">{{ section.icon || 'circle' }}</mat-icon>
          }
          <span class="section-label">{{ section.label }}</span>
          <span class="section-badge" *ngIf="section.badge && +section.badge > 0">{{
            section.badge
          }}</span>
        </div>
        <mat-icon class="section-arrow" *ngIf="getSubmenuItems(section).length > 0"
          >chevron_right</mat-icon
        >
      </button>
    </div>
  </nav>

  <div
    class="floating-submenu"
    *ngIf="openSubmenuItems.length > 0 && submenuPosition"
    [style.top]="submenuPosition.top === null ? null : submenuPosition.top + 'px'"
    [style.bottom]="submenuPosition.bottom === null ? null : submenuPosition.bottom + 'px'"
    [style.left.px]="submenuPosition.left"
    (mouseenter)="onFloatingSubmenuMouseEnter()"
  >
    <ng-container *ngFor="let subItem of openSubmenuItems; trackBy: trackBySubItem">
      <div class="submenu-divider" *ngIf="subItem.dividerBefore" role="separator"></div>
      <button
        type="button"
        class="submenu-item"
        [class.active]="isSubmenuItemActive(subItem)"
        (click)="onSubmenuItemClick(subItem)"
      >
        <mat-icon
          class="submenu-icon"
          *ngIf="subItem.isCustomIcon"
          [svgIcon]="subItem.icon"
        ></mat-icon>
        <mat-icon class="submenu-icon" *ngIf="!subItem.isCustomIcon">{{ subItem.icon }}</mat-icon>
        <span class="submenu-label">{{ subItem.label }}</span>
        <span
          class="submenu-badge"
          *ngIf="
            subItem.key === 'assignments' &&
            permissionUtils.canApplyDownPayment() &&
            downPaymentService.pendingCount() > 0
          "
        >
          {{ downPaymentService.pendingCount() }}
        </span>
      </button>
    </ng-container>
  </div>

  <div class="sidebar-bottom">
    <button
      type="button"
      class="logout-button"
      aria-label="Sign out"
      [ewentsTooltip]="showCollapsedUi ? 'Sign out' : ''"
      ewentsTooltipPosition="right"
      (click)="onLogout()"
    >
      <mat-icon class="logout-icon" svgIcon="logout"></mat-icon>
      <span>Sign out</span>
    </button>
  </div>
</aside>
